import * as React from 'react';
import 'mapbox-gl/dist/mapbox-gl.css';

import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Button, FormControl,
    IconButton, Input, InputLabel, MenuItem,
    Pagination, Select, TextField,
    Typography,
} from "@mui/material";
import SouffletsAnalyse from "./final/SouffletsAnalyse";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Synthese from "./Synthese";
import {correctId, correctName, getColor, mappingChelou} from "../Utils";

import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import MapBvs from "./final/maps/MapBvs";
import {useStyles} from "../Style";
import PrintIcon from "@mui/icons-material/Print";
import Checkbox from '@mui/material/Checkbox';
import generatePDF, {Margin, Resolution, usePDF} from "react-to-pdf";
import {useState} from "react";
import {CheckBox} from "@mui/icons-material";
import BVSoufflet from "./BVSoufflet";

import SearchIcon from '@mui/icons-material/Search';

export default function GroupByBvs({
                                       resultsByBvsSynthese,
                                       resultsGeomByBvsSynthese,
                                       resultsGeomIrisByBvsSynthese,
                                       resultsByBvs,
                                       resultsByIris,
                                       resultsParCandidatsByBvs,
                                       resultsParDonneesInseeByBvs,
                                       codeInsee,
                                       filterBv,
                                       filterIris,
                                       filterStatus,
                                       mappingBvArrondissement,
                                       showPersonae,
                                       otherResults,
                                       border,
                                       electionType
                                   }) {

    const [bvs, setBvs] = React.useState(null);

    const [order, setOrder] = React.useState("desc");
    const [orderType, setOrderType] = React.useState("nbInscrit");

    const [orderBy, setOrderBy] = React.useState(null);
    const [bvsPerPage, setBvsPerPage] = React.useState(5);

    const [page, setPage] = React.useState(1);

    React.useEffect(() => {
        if (resultsByBvsSynthese) {
            let results = [];
            let orderBy = {};
            let inscritsNb = []
            let abstentionsPerc = []
            Object.keys(resultsByBvsSynthese).forEach((key, index) => {
                Object.keys(resultsByBvsSynthese[key]).forEach((bvId, index2) => {
                    let bv = JSON.parse(JSON.stringify(resultsByBvsSynthese[key][bvId]));
                    const splitKey = bvId.split("_");
                    const correctedId = splitKey[0].padStart(5, '0') + "_" + splitKey[1].padStart(4, '0');

                    bv.inscrit = bv.results[0].inscrit;
                    bv.abstention = bv.results[0].abstention;

                    inscritsNb.push(bv.inscrit.nb);
                    abstentionsPerc.push(bv.abstention.perc);

                    orderBy[correctedId] = {
                        inscrit: bv.inscrit.nb,
                        inscritPos: -1,
                        abstention: bv.abstention.perc,
                        abstentionsPos: -1,

                    }

                })
            })
            inscritsNb = inscritsNb.sort((a, b) => {
                return a - b
            }).reverse();
            abstentionsPerc = abstentionsPerc.sort((a, b) => {
                return a - b
            }).reverse();
            Object.keys(resultsByBvsSynthese).forEach((key, index) => {
                Object.keys(resultsByBvsSynthese[key]).forEach((bvId, index) => {
                    let bv = JSON.parse(JSON.stringify(resultsByBvsSynthese[key][bvId]));
                    const correctedId = correctId(bvId);

                    bv.inscrit = bv.results[0].inscrit;
                    bv.abstention = bv.results[0].abstention;
                    bv.tour = "dsqdqs"
                    let posInscrit = inscritsNb.findIndex((elem) => {
                        return elem === bv.inscrit.nb;
                    })
                    let posAbstention = abstentionsPerc.findIndex((elem) => {
                        return elem === bv.abstention.perc;
                    });
                    orderBy[correctedId].inscritPos = posInscrit + 1;
                    orderBy[correctedId].abstentionsPos = posAbstention + 1;

                })
            })

            setOrderBy(orderBy);

            let opened = {};
            Object.keys(resultsByBvsSynthese).forEach((key, index) => {
                (Object.keys(resultsByBvsSynthese[key]).forEach((bvId, index) => {
                    let bv = JSON.parse(JSON.stringify(resultsByBvsSynthese[key][bvId]));
                    const splitKey = bvId.split("_");
                    const numBv = splitKey[1].padStart(4, '0');
                    bv.key = correctId(bvId);
                    bv.color = key;
                    bv.inscrit = bv.results[0].inscrit;
                    bv.abstention = bv.results[0].abstention;
                    bv.bvId = Number(numBv);
                    bv.bvIdText = numBv;

                    results.push(bv);
                }))
            })
            setBvs(results)
        }
    }, [resultsByBvsSynthese])


    function getOrderIcon(booltocheck) {
        if (booltocheck) {
            if (order === "asc") {
                return <ArrowUpwardIcon/>;
            } else {
                return <ArrowDownwardIcon/>;
            }
        }
        return null;
    }

    function getNumberOfPage(bvsPerPage) {
        let res = bvs.filter((a) => {
                let mappingBv = {}
                Object.keys(mappingBvArrondissement).forEach((bvId) => {
                    mappingBv[mappingBvArrondissement[bvId]] = bvId;
                })
                let irisIsIn = 0;
                let k = a.key;
                let splitKey = k.split("_");

                let k_fr_paris = splitKey[0].padStart(5, '0') + "_" + splitKey[1].padStart(4, '0');
                let splitKey2 = splitKey;
                if (mappingBv[k_fr_paris]) {
                    splitKey2 = mappingBv[k_fr_paris].split("_");
                }

                let mapped_k_fr_paris = splitKey2[0].padStart(5, '0') + "_" + splitKey2[1].padStart(4, '0');

                if (mappingChelou[k] && resultsParDonneesInseeByBvs[mappingChelou[k].proxy]) {
                    k = mappingChelou[k].proxy
                } else if (mappingBv[k] && resultsParDonneesInseeByBvs[mappingBv[k]]) {
                    k = mappingBv[k];
                } else if (resultsParDonneesInseeByBvs[mapped_k_fr_paris]) {

                    k = mapped_k_fr_paris;
                }
                if (resultsParDonneesInseeByBvs[k]) {
                    resultsParDonneesInseeByBvs[k].listOfIris.forEach((iris) => {
                        if (filterIris.includes(iris)) {
                            irisIsIn += 1;
                        }
                    })
                    return irisIsIn !== resultsParDonneesInseeByBvs[k].listOfIris.length &&
                        !filterBv.includes(k) &&
                        !filterStatus.includes(a.color);
                }

            }
        )
        let r = Math.ceil(res.length / bvsPerPage);
        if (r > 0 && page > r) {

            setPage(r)
        }
        return r;
    }

    if (bvs) {
        return (
            <Box sx={{width: "100%", display: "flex", flexDirection: "column", gap: 2, mt: 3}}>
                <Typography variant="h5" sx={{}}>
                    Nombre total de Bureau de vote : {bvs.length}
                </Typography>
                <Box sx={{m: 1, display: "flex", flexDirection: "row", alignItems: "center", gap: "20px"}}>
                    <Typography>Trie par : </Typography>
                    <Box sx={{display: "flex", flexDirection: "row", gap: "20px", height: 56}}>
                        <Button
                            variant="contained"
                            sx={{justifyContent: "space-between", backgroundColor: '#cd2b89'}}
                            onClick={() => {
                                if (orderType === "nbInscrit") {
                                    setOrder(order === "asc" ? "desc" : "asc");
                                }
                                setOrderType("nbInscrit")
                            }}>
                            Nombre d'inscrit {getOrderIcon(orderType === "nbInscrit")}
                        </Button>
                        <Button
                            variant="contained"
                            sx={{justifyContent: "space-between", backgroundColor: '#cd2b89'}}
                            onClick={() => {
                                if (orderType === "nbAbstention") {
                                    setOrder(order === "asc" ? "desc" : "asc");
                                }
                                setOrderType("nbAbstention")
                            }}>
                            Taux d'abstention {getOrderIcon(orderType === "nbAbstention")}
                        </Button>
                        <Button
                            variant="contained"
                            sx={{justifyContent: "space-between", backgroundColor: '#cd2b89'}}
                            onClick={() => {
                                if (orderType === "num") {
                                    setOrder(order === "asc" ? "desc" : "asc");
                                }
                                setOrderType("num")
                            }}>
                            Numéro de bureau {getOrderIcon(orderType === "num")}
                        </Button>
                        <Button
                            variant="contained"
                            sx={{justifyContent: "space-between", backgroundColor: '#cd2b89'}}
                            onClick={() => {
                                if (orderType === "vict") {
                                    setOrder(order === "asc" ? "desc" : "asc");
                                }
                                setOrderType("vict")
                            }}>
                            Victoire {getOrderIcon(orderType === "vict")}
                        </Button>
                    </Box>
                    <Box sx={{display: "flex", flexDirection: "column", width: "100px"}}>
                        <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">Par page</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={bvsPerPage}
                                label="Par page"
                                onChange={(value) => {
                                    setBvsPerPage(value.target.value)
                                }}
                            >
                                <MenuItem value={5}>5</MenuItem>
                                <MenuItem value={10}>10</MenuItem>
                                <MenuItem value={20}>20</MenuItem>
                                <MenuItem value={50}>50</MenuItem>
                            </Select>
                        </FormControl>
                    </Box>

                    <Box sx={{
                        display: 'flex',
                        alignItems: 'flex-end',
                        borderStyle: 'solid',
                        borderRadius: 1,
                        color: '#cd2b89',
                        borderWidth: 1
                    }}>
                        <TextField id="input-with-sx" label="Rechercher un BV" variant="outlined" disabled/>
                    </Box>
                </Box>
                <Box sx={{
                    width: "100%",
                    m: 2,
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "center"
                }}>
                    <Pagination count={getNumberOfPage(bvsPerPage)} page={page} onChange={(value, page) => {

                        setPage(page)
                    }}/>
                </Box>
                <Box sx={{width: "100%", display: "flex", flexDirection: "column", gap: "20px", mt: 2}}>
                    {orderBy && orderBy && bvs && bvs
                        .sort((a, b) => {
                            let aInscrit = a.inscrit.nb;
                            let bInscrit = b.inscrit.nb;
                            if (orderType === "nbAbstention") {
                                aInscrit = a.abstention.perc;
                                bInscrit = b.abstention.perc;
                            } else if (orderType === "num") {
                                aInscrit = a.bvId;
                                bInscrit = b.bvId;
                            } else if (orderType === "vict") {
                                aInscrit = a.results[0].winner.perc;
                                bInscrit = b.results[0].winner.perc;
                            }
                            if (order === "asc") {
                                return aInscrit - bInscrit;
                            } else {
                                return bInscrit - aInscrit;
                            }
                        })

                        .filter((a) => {
                            let mappingBv = {}
                            Object.keys(mappingBvArrondissement).forEach((bvId) => {
                                mappingBv[mappingBvArrondissement[bvId]] = bvId;
                            })
                            let irisIsIn = 0;
                            let k = a.key;
                            let k_fr_paris = k
                            if (mappingBv[k]) {
                                k_fr_paris = mappingBv[k]
                            }
                            let splitKey = k_fr_paris.split("_");
                            let mapped_k_fr_paris = splitKey[0].padStart(5, '0') + "_" + splitKey[1].padStart(4, '0');

                            if (!resultsParDonneesInseeByBvs[k] && mappingChelou[k]) {
                                k = mappingChelou[k].proxy
                            }
                            if (!resultsParDonneesInseeByBvs[k] && mappingBv[k]) {
                                k = mappingBv[k]
                            }
                            if (!resultsParDonneesInseeByBvs[k] && resultsParDonneesInseeByBvs[mapped_k_fr_paris]) {
                                k = mapped_k_fr_paris;
                            }
                            if (resultsParDonneesInseeByBvs[k]) {
                                resultsParDonneesInseeByBvs[k].listOfIris.forEach((iris) => {
                                    if (filterIris.includes(iris)) {
                                        irisIsIn += 1;
                                    }
                                })
                                return irisIsIn !== resultsParDonneesInseeByBvs[k].listOfIris.length &&
                                    !filterBv.includes(k) &&
                                    !filterStatus.includes(a.color);
                            }
                        })
                        .filter((a, id) => {
                            return id >= (page - 1) * bvsPerPage && id < page * bvsPerPage;
                        })
                        .map((bv, id) => {
                            let filterBvTmp = Object.keys(orderBy);
                            let index = filterBvTmp.findIndex((elem) => {
                                return elem === bv.key;
                            })
                            filterBvTmp.splice(index, 1);
                            let rangInscrit = orderBy[bv.key].inscritPos;
                            let rangAbstention = orderBy[bv.key].abstentionsPos;

                            let mappingBv = {}
                            Object.keys(mappingBvArrondissement).forEach((bvId) => {
                                mappingBv[mappingBvArrondissement[bvId]] = bvId;
                            })
                            let k = bv.key;

                            if (mappingBv[k]) {
                                k = mappingBv[k]
                            }

                            let listOfAddress = {}

                            Object.keys(resultsByIris).forEach((key, k20) => {
                                Object.keys(resultsByIris[key].bvs).forEach((id, k21) => {
                                    let kCorr = k;
                                    kCorr = kCorr
                                        .replace("13201", "13055")
                                        .replace("13202", "13055")
                                        .replace("13203", "13055")
                                        .replace("13204", "13055")
                                        .replace("13205", "13055")
                                        .replace("13206", "13055")
                                        .replace("13207", "13055")
                                        .replace("13208", "13055")
                                        .replace("13209", "13055")
                                        .replace("13210", "13055")
                                        .replace("13211", "13055")
                                        .replace("13212", "13055")
                                        .replace("13213", "13055")
                                        .replace("13214", "13055")
                                        .replace("13215", "13055")
                                        .replace("13216", "13055")

                                        .replace("69381", "69123")
                                        .replace("69382", "69123")
                                        .replace("69383", "69123")
                                        .replace("69384", "69123")
                                        .replace("69385", "69123")
                                        .replace("69386", "69123")
                                        .replace("69387", "69123")
                                        .replace("69388", "69123")
                                        .replace("69389", "69123")

                                        .replace("75101", "75056")
                                        .replace("75102", "75056")
                                        .replace("75103", "75056")
                                        .replace("75104", "75056")
                                        .replace("75105", "75056")
                                        .replace("75106", "75056")
                                        .replace("75107", "75056")
                                        .replace("75108", "75056")
                                        .replace("75109", "75056")
                                        .replace("75110", "75056")
                                        .replace("75111", "75056")
                                        .replace("75112", "75056")
                                        .replace("75113", "75056")
                                        .replace("75114", "75056")
                                        .replace("75115", "75056")
                                        .replace("75116", "75056")
                                        .replace("75117", "75056")
                                        .replace("75118", "75056")
                                        .replace("75119", "75056")
                                        .replace("75120", "75056")

                                    if (id === kCorr) {
                                        const correctedId = correctId(id);
                                        let finalCorrectedId = correctedId
                                        if (mappingBvArrondissement[correctedId]) {
                                            finalCorrectedId = mappingBvArrondissement[correctedId];
                                        }
                                        let bvs = resultsByIris[key].bvs[finalCorrectedId];
                                        console.log(resultsByIris[key]);
                                        bvs.bans.forEach((ban, index) => {
                                            let idSplitted = ban.codeBan.split("_", -1)
                                            let idd = idSplitted[0] + "_" + idSplitted[1];
                                            let addresse = correctName(ban.libelleBan);
                                            let num = addresse.split(" ", -1);
                                            console.log(idd);
                                            if (!listOfAddress[idd]) {
                                                let finalAddress = addresse.replace(num[0] + " ", "");
                                                let zip = finalAddress.match(/(\d{5})/g);
                                                let pos = finalAddress.indexOf(zip[0])
                                                listOfAddress[idd] = {
                                                    numeros: [],
                                                    code: idd,
                                                    addresse: finalAddress.substring(0, pos),
                                                };
                                            }
                                            if (num[0].match(/^\d/)) {
                                                listOfAddress[idd].numeros.push(num[0]);
                                            } else {
                                                if (listOfAddress[idd].numeros.length === 0) {
                                                    listOfAddress[idd].addresse = num[0] + " " + listOfAddress[idd].addresse;
                                                }
                                            }
                                        })
                                    }
                                })
                            })

                            return (<BVSoufflet
                                key={k}
                                bv={bv}
                                k={k}
                                rangInscrit={rangInscrit}
                                rangAbstention={rangAbstention}
                                resultsByBvsSynthese={resultsByBvsSynthese}
                                resultsGeomByBvsSynthese={resultsGeomByBvsSynthese}
                                resultsGeomIrisByBvsSynthese={resultsGeomIrisByBvsSynthese}
                                resultsByIris={resultsByIris}
                                resultsByBvs={resultsByBvs}
                                resultsParCandidatsByBvs={resultsParCandidatsByBvs}
                                resultsParDonneesInseeByBvs={resultsParDonneesInseeByBvs}
                                codeInsee={codeInsee}
                                showPersonae={showPersonae}
                                filterBvTmp={filterBvTmp}
                                mappingBvArrondissement={mappingBv}
                                listOfAddress={listOfAddress}
                                otherResults={otherResults}
                                border={border}
                                electionType={electionType}
                            />)


                        })}
                </Box>
                <Box sx={{
                    width: "100%",
                    m: 2,
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "center"
                }}>
                    <Pagination count={getNumberOfPage(bvsPerPage)} page={page} onChange={(value, page) => {

                        setPage(page)
                    }}/>
                </Box>
            </Box>
        );
    }

}
